
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M152 416H112a8 8 0 000 16h40a8 8 0 000-16zM184 416h-8a8 8 0 000 16h8a8 8 0 000-16z"}}),_c('path',{attrs:{"d":"M463 8H16a8 8 0 000 16H152V64a8 8 0 008 8h88V232h-8a8 8 0 00-8 8v25.55A184.043 184.043 0 0072 448a8 8 0 008 8H200.58a55.994 55.994 0 00110.84 0H432a8 8 0 008-8A184.043 184.043 0 00280 265.55V240a8 8 0 00-8-8h-8V72h88a8 8 0 008-8V24H463a8 8 0 000-16zM256 488a40.069 40.069 0 01-39.2-32h78.4A40.069 40.069 0 01256 488zm15.28-207.31A168 168 0 01423.81 440H88.19A168 168 0 01240.72 280.69a8 8 0 007.28-7.97V248h16v24.72A8 8 0 00271.28 280.69zM344 56H168V24H344zM496 8h-8a8 8 0 000 16h8a8 8 0 000-16z"}})])
          )
        }
      }
    